import { ActionType } from '../constants/ActionType';
import { AuthAction } from '../actions';
import { Reducer } from 'redux';

export interface AuthState {
  initialized: boolean;
  loading: boolean;
  message: string;
  redirect: string;
  redirectQueryParams?: string;
  email?: string;
  token: string | null;
}

const initState: AuthState = {
  initialized: false,
  loading: false,
  message: '',
  redirect: '/',
  token: null,
};

const auth: Reducer<AuthState, AuthAction> = (state: AuthState = initState, action: AuthAction): AuthState => {
  switch (action.type) {
    case ActionType.UPDATE_AUTH_STATE: {
      const { type, ...others } = action;
      return {
        ...state,
        ...others,
      };
    }
    case ActionType.SET_SIGN_IN_REDIRECT: {
      return {
        ...state,
        redirect: action.redirect,
        redirectQueryParams: action.redirectQueryParams,
      };
    }
    case ActionType.SHOW_AUTH_MESSAGE:
      return {
        ...state,
        message: action.message,
        loading: false,
      };
    case ActionType.HIDE_AUTH_MESSAGE:
      return {
        ...state,
        message: '',
      };
    case ActionType.SIGNOUT: {
      return {
        ...state,
        token: null,
        redirect: '/',
        loading: false,
      };
    }
    case ActionType.SHOW_LOADING: {
      return {
        ...state,
        loading: true,
      };
    }
    case ActionType.HIDE_LOADING: {
      return {
        ...state,
        loading: false,
      };
    }
    default:
      return state;
  }
};

export default auth;
